export default [
    {
        path: '/rental/create/projectId/:projectId',
        component: require('@/pages/RentalCreate').default,
        props: (route) => ({
            projectId: +route.params.projectId
        }),
        meta: {
            back: { label: ':projectName', to: '/project/view/:projectId' },
            security: (auth) => auth.can({ action: 'create', model: 'rental', arg: +auth.to.params.projectId })
        }
    },
    {
        path: '/rental/list',
        component: require('@/pages/RentalList').default,
        meta: {
            back: { label: 'Dashboard', to: '/' },
            security: (auth) => auth.can({ action: 'list', model: 'rental' })
        }
    },
    {
        path: '/rental/view/projectId/:projectId/:rentalId',
        component: require('@/pages/RentalView').default,
        props: (route) => ({
            rentalId: +route.params.rentalId
        }),
        meta: {
            back: { label: ':projectName', to: '/project/view/:projectId' },
            security: (auth) => auth.can({ action: 'view', model: 'rental', arg: +auth.to.params.rentalId })
        }
    },
    {
        path: '/rental/view/:rentalId',
        component: require('@/pages/RentalView').default,
        props: (route) => ({
            rentalId: +route.params.rentalId
        }),
        meta: {
            back: { label: 'Rental List', to: '/rental/list' },
            security: (auth) => auth.can({ action: 'view', model: 'rental', arg: +auth.to.params.rentalId })
        }
    },
    {
        path: '/rentalcompany/list',
        component: require('@/pages/RentalCompanyList').default,
        meta: {
            back: { label: 'Dashboard', to: '/' },
            security: (auth) => auth.can({ action: 'list', model: 'rental-company' })
        }
    },
    {
        name: 'rentalCompanyCreate',
        path: '/rentalcompany/create',
        component: require('@/pages/RentalCompanyCreate').default,
        meta: {
            back: { label: 'Rental Companies', to: '/rentalcompany/list' },
            security: (auth) => auth.can({ action: 'create', model: 'rental-company' })
        }
    }
]